import React from 'react';
import { Link } from 'react-router-dom';
import { Play, ArrowRight } from 'lucide-react';
import { recentWork, brandStoriesFeaturedIds } from '../mock';

const WorkCard = ({ w, onPlay }) => (
  <button
    onClick={() => onPlay(w.youtubeId, w.title)}
    data-testid={`work-card-${w.id}`}
    className="group relative rounded-2xl overflow-hidden text-left border border-white/10 hover:border-[#c9a85f]/60 transition-all aspect-[16/10]"
  >
    <img
      src={w.thumb}
      alt={w.title}
      className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
      loading="lazy"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" />
    <div className="absolute inset-0 flex items-center justify-center">
      <span className="flex items-center justify-center w-16 h-16 rounded-full bg-[#c9a85f]/90 text-black scale-90 opacity-90 group-hover:scale-100 group-hover:opacity-100 transition-all shadow-xl">
        <Play size={24} className="fill-black ml-1" />
      </span>
    </div>
    <div className="absolute top-4 left-4">
      <span className="font-display text-[10px] tracking-widest uppercase bg-black/60 backdrop-blur text-[#c9a85f] px-3 py-1 rounded-full border border-[#c9a85f]/30">
        {w.category}
      </span>
    </div>
    <div className="absolute bottom-0 left-0 right-0 p-6">
      <p className="text-white/70 text-xs font-semibold uppercase tracking-wide mb-1">{w.client}</p>
      <h3 className="font-display font-semibold text-white text-lg md:text-xl leading-tight uppercase group-hover:text-[#c9a85f] transition-colors">
        {w.title}
      </h3>
    </div>
  </button>
);

const Work = ({ onPlay }) => {
  const featured = brandStoriesFeaturedIds
    .map((id) => recentWork.find((w) => w.id === id))
    .filter(Boolean);
  const top = featured.slice(0, 2);
  const rest = featured.slice(2);

  return (
    <section id="brand-stories" className="py-24 md:py-32 max-w-7xl mx-auto px-6 scroll-mt-24">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
        <div>
          <p className="font-display tracking-[0.35em] text-[#c9a85f] text-sm uppercase mb-5">Brand Stories</p>
          <h2 className="font-display font-bold text-white text-4xl md:text-6xl uppercase leading-[1]">
            We create brand stories
          </h2>
        </div>
        <p className="text-white/75 max-w-sm text-sm md:text-base font-medium leading-relaxed">
          Real teams, real results — a selection of the brand films we've crafted. Tap any to watch.
        </p>
      </div>

      {/* Featured row — two equal-size cards */}
      <div className="grid md:grid-cols-2 gap-6">
        {top.map((w) => (
          <WorkCard key={w.id} w={w} onPlay={onPlay} />
        ))}
      </div>

      {/* Remaining work */}
      {rest.length > 0 && (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
          {rest.map((w) => (
            <WorkCard key={w.id} w={w} onPlay={onPlay} />
          ))}
        </div>
      )}

      <div className="mt-12 text-center">
        <Link
          to="/brand-stories"
          onClick={() => window.scrollTo(0, 0)}
          data-testid="brand-stories-view-all"
          className="group inline-flex items-center gap-3 border border-[#c9a85f]/50 hover:bg-[#c9a85f] hover:text-black text-white font-display font-semibold px-7 py-3.5 rounded-md transition-colors tracking-wide"
        >
          View All Brand Stories
          <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
        </Link>
      </div>
    </section>
  );
};

export default Work;
